import type { SwiperProps } from "swiper/react"
import { Swiper as SwiperReact, SwiperSlide } from "swiper/react"
import { Autoplay, A11y, Keyboard, Navigation, Pagination, EffectFade } from "swiper/modules"
// Imported here (not just in views/_app.tsx) so the styles are guaranteed
// to be bundled wherever this component is used, including the Gutenberg
// block-editor's admin bundle for `Mode: preview` blocks.
import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/a11y"
import "swiper/css/keyboard"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/effect-fade"

// Real React components (swiper/react) instead of the web-component/custom-
// elements build — that build relies on customElements.define(), which
// broke inside Gutenberg's iframed block-editor canvas (a separate window
// with its own customElements registry, so elements created there never
// got upgraded into real Swiper instances). swiper/react manages the
// Swiper instance directly via refs/lifecycle, no custom elements involved.
function Swiper(props: SwiperProps) {
  const { children, ...rest } = props
  return (
    <SwiperReact modules={[Autoplay, A11y, Keyboard, Navigation, Pagination, EffectFade]} {...rest}>
      {children}
    </SwiperReact>
  )
}

export { Swiper, SwiperSlide }
